import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Back arrow for the standalone partner pages (MorseBridge / Certifii / Vaultinum).
 *
 * These pages are reached from a dashboard tab in the same browser tab, so the visitor needs a way
 * back. Falls back to the home page when there is no history to pop — e.g. the URL was opened
 * directly or pasted — so the button is never a dead end.
 */
const PageBackButton = ({ className = '' }) => {
    const navigate = useNavigate();
    const goBack = () => {
        if (window.history.length > 1) navigate(-1);
        else navigate('/');
    };

    return (
        <button type="button" onClick={goBack} className={`dlg-page-back ${className}`.trim()} aria-label="Go back">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M19 12H5" />
                <path d="M12 19l-7-7 7-7" />
            </svg>
            <span>Back</span>
        </button>
    );
};

export default PageBackButton;
